// Registre central des articles du Magazine Hebdomadaire CODE 2 ROUES.
// Chaque entrée correspond à une édition Hero hebdomadaire (Volume X) et
// à un article complet sur /magazine/{slug}.

import { barometreIsereMai2026Article } from './barometreIsereMai2026';
import { barometreAvril2026Article } from './barometreAvril2026';
import { barometreJuillet2026Article } from './barometreJuillet2026';
import { contreBraquageArticle } from './contreBraquage';
import { deathGripArticle } from './deathGrip';
import { hiverMotoArticle } from './hiverMoto';
import { demiTourMotoArticle } from './demiTourMoto';
import { freinageUrgenceArticle } from './freinageUrgence';
import { equilibreMotoArticle } from './equilibreMoto';
import { permisA1A2Article } from './permisA1A2';
import { casqueArticle } from './casque';
import { gantsArticle } from './gants';
import { alcoolArticle } from './alcool';
import { distancesArticle } from './distances';
import { trajectoiresArticle } from './trajectoires';
import { zfeArticle } from './zfe';
import { autorouteArticle } from './autoroute';
import { telephoneArticle } from './telephone';
import { epiArticle } from './epi';
import { plateauArticle } from './plateau';
import { livreursArticle } from './livreurs';
import { assr1Article } from './assr1';
import { assr2Article } from './assr2';
import { petitGabaritArticle } from './petitGabarit';
import { premiereMotoArticle } from './premiereMoto';

export const MAGAZINE_ARTICLES = [
  hiverMotoArticle, // Vol. 44 — PROCHAINE UNE (nov 2026, conduire en hiver à moto)
  deathGripArticle, // Vol. 38 — À LA UNE OCTOBRE (oct 2026, conseils posture & souplesse)
  contreBraquageArticle, // Vol. 37 (sept 2026, dossier technique contre-braquage)
  demiTourMotoArticle, // Vol. 33 (août 2026, demi-tour méthode complète)
  freinageUrgenceArticle, // Vol. 32 (août 2026, freinage d'urgence technique complet)
  equilibreMotoArticle, // Vol. 36 (sept 2026, technique équilibre basse vitesse)
  barometreJuillet2026Article, // Vol. 35 (août 2026, baromètre ONISR juillet)
  premiereMotoArticle, // Vol. 34 (août 2026, première leçon plateau + livret CODE 2 ROUES)
  petitGabaritArticle, // Vol. 31
  barometreIsereMai2026Article, // Vol. 22
  barometreAvril2026Article, // Vol. 21 (mai 2026, alerte mortalité moto nationale)
  permisA1A2Article, // Vol. 20
  plateauArticle,
  livreursArticle,
  assr1Article,
  assr2Article,
  casqueArticle,
  gantsArticle,
  alcoolArticle,
  distancesArticle,
  trajectoiresArticle,
  zfeArticle,
  autorouteArticle,
  telephoneArticle,
  epiArticle,
];

export const MAGAZINE_BY_SLUG = MAGAZINE_ARTICLES.reduce((acc, a) => {
  acc[a.slug] = a;
  return acc;
}, {});

export function getArticle(slug) {
  return MAGAZINE_BY_SLUG[slug] || null;
}
